var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-pause-solid",
    clipPath: "url(#clip0_633_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16003 23.7938C4.78003 23.7938 3.66003 22.6738 3.66003 21.2938V2.29382C3.66003 0.913823 4.78003 -0.206177 6.16003 -0.206177C7.54003 -0.206177 8.66003 0.913823 8.66003 2.29382V21.2938C8.66003 22.6738 7.54003 23.7938 6.16003 23.7938ZM19.9 21.2938V2.29382C19.9 0.913823 18.78 -0.206177 17.4 -0.206177C16.02 -0.206177 14.9 0.913823 14.9 2.29382V21.2938C14.9 22.6738 16.02 23.7938 17.4 23.7938C18.78 23.7938 19.9 22.6738 19.9 21.2938Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_2280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause2);
export default __webpack_public_path__ + "static/media/pause2.0f93dcc2ed65c18654d9ef9366da36f2.svg";
export { ForwardRef as ReactComponent };